<template>
    <div class="card mb-1 shadow-none" id="box_plan_surat_penunjang" ref="box_plan_surat_penunjang">
        <div class="card-header">
            <b-button
                id="btn_plan_surat_penunjang"
                class="btn btn-link btn-lg btn-block px-0 d-flex align-items-center justify-content-between shadow-none"
                :class="SuratPenunjangIsShown ? null : 'collapsed'" @click="SuratPenunjangIsShown = !SuratPenunjangIsShown"
            >
                <span class="text-capitalize">surat penunjang</span>
                <font-awesome-icon icon="angle-up" class="font-size-xl" />
            </b-button>
        </div>
        <b-collapse id="plan_surat_penunjang" v-model="SuratPenunjangIsShown" accordion="plan_child" role="tabpanel">
            <div class="card-body pb-5" v-if="SuratPenunjangIsShown">
                <div class="row">
                    <div class="col-7 mx-4">
                        <Basic @DoneLoadingBasic="HandleDoneLoadingBasic"/>
                    </div>
                </div>

                <div class="row" v-if="CurrentlyComposeLetter">
                    <div class="col-12 my-3">
                        <SuratPenunjangForm />
                    </div>
                </div>

                <div class="row" v-else>
                    <div class="col-12">
                        <SuratPenunjangList v-if="ShowPenunjangList"/>
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'SuratPenunjangIndex',
    data() {
        return {
            SuratPenunjangIsShown: false,
            ShowPenunjangList: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.ResetSuratPenunjangStore()
        })
    },
    beforeDestroy() {
        this.$nextTick(() => {
            this.ResetSuratPenunjangStore()
        })
    },
    computed: {
        ...mapState('SuratPenunjangStore', ['CurrentlyComposeLetter'])
    },
    components: {
        Basic: () => import('./Basic.vue'),
        SuratPenunjangForm: () => import('./Forms/SuratPenunjangForm.vue'),
        SuratPenunjangList: () => import('./Forms/SuratPenunjangList.vue')
    },
    methods: {
        ...mapActions('SuratPenunjangStore', ['ResetSuratPenunjangStore']),
        ...mapActions('SuratPenunjangStore', ['ResetSuratPenunjangStore']),
        HandleDoneLoadingBasic() {
            this.ShowPenunjangList = true
        }
    }
}
</script>

<style scoped>
.card {
    overflow: visible;
}
</style>